import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-78d1806f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    name: "warn-list"
};
const _hoisted_2 = { class: "boxes" };
import InvalidField from '@/materials/atoms/InvalidField.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        message: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (__props.message)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.message, (label) => {
                        return (_openBlock(), _createElementBlock("div", { key: label }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(InvalidField, {
                                    "is-invalid": true,
                                    message: label,
                                    class: "msg-err"
                                }, null, 8, ["message"])
                            ])
                        ]));
                    }), 128))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
